/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useContext } from 'react';
import Button from 'button/loading';
import useCustomer from 'hooks/useCustomer';
import { context } from 'context/cart-preview';
import ErrorBlock from 'shared/shopify-error-block';
import usePaymentRef from './usePaymentRef';
import paymentFormStyles from '../payment.module.scss';
import styles from './payment-form.module.scss';

const s = {
  ...paymentFormStyles,
  ...styles
};

export default function PaymentForm({
  checkoutId,
  billingAddress,
  emitGlobal,
  stateGlobal
}) {
  const { cart } = useContext(context);
  const { customer } = useCustomer();

  const checkoutToken = cart.checkoutUrl.replace(
    /(.*?checkouts\/| ?\?.*$)/gm,
    ''
  );
  const { paymentForm, active, ready } = usePaymentRef({
    emitGlobal,
    checkoutId,
    checkoutToken,
    billingAddress,
    customerId: customer?.id
  });

  const handleSubmit = e => {
    e.preventDefault();
    emitGlobal.update({
      paymentProcessing: true,
      paymentErrors: false,
    });
    paymentForm.current.requestCardNonce();
  };

  useEffect(() => {
    if (paymentForm.current) {
      paymentForm.current.build();
    }
  }, [paymentForm]);

  return (
    <div className={s.block}>
      <p className={s.title}>Payment Form</p>
      <div className={`${s.blockWrapper} ${s[active]}`}>
        <div id="form-container" className={`${s.form} ${s[active]}`}>
          <div id="sq-card-number" className={s.input} />
          <div id="sq-expiration-date" className={s.input} />
          <div id="sq-cvv" className={`${s.input} ${s.noMargin}`} />
          <div id="sq-postal-code" className={`${s.input} ${s.last}`} />
          <div className={s.button}>
            <Button
              id="sq-creditcard"
              type="button"
              small
              onClick={handleSubmit}
              loading={!ready}
            >
              Place Order
            </Button>
            <ErrorBlock className={s.errorBock} shopifyErrors={stateGlobal.paymentErrors} />
          </div>
        </div>
      </div>
    </div>
  );
}
